import { render, staticRenderFns } from "./AlarmaGlobalComponent.vue?vue&type=template&id=3eff8927&scoped=true"
import script from "./AlarmaGlobalComponent.vue?vue&type=script&lang=js"
export * from "./AlarmaGlobalComponent.vue?vue&type=script&lang=js"
import style0 from "./AlarmaGlobalComponent.vue?vue&type=style&index=0&id=3eff8927&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eff8927",
  null
  
)

export default component.exports